import React, { useContext } from 'react';

import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  useTheme,
} from '@material-ui/core';
import { alpha } from '@material-ui/core/styles';
import { FiCheck } from 'react-icons/fi';

import { DeviceContext } from '@vyce/core/src/contexts';
import { MAIN_CONTAINER_ID } from '@vyce/core/src/constants';

interface Props {
  open: boolean;
  onClose: () => void;
}

export const MessagingActivatedDialog: React.FC<Props> = ({ open, onClose }) => {
  const theme = useTheme();
  const { isMobile } = useContext(DeviceContext);
  const isDark = theme.palette.type === 'dark';

  return (
    <Dialog
      container={document.getElementById(MAIN_CONTAINER_ID)}
      fullScreen={isMobile}
      open={open}
      onClose={onClose}
    >
      <Box display="flex" justifyContent="center" paddingTop={4}>
        <Box
          width={56}
          height={56}
          borderRadius="50%"
          display="flex"
          alignItems="center"
          justifyContent="center"
          style={{ backgroundColor: alpha(theme.palette.success.main, isDark ? 0.16 : 0.08) }}
        >
          <FiCheck size={26} color={theme.palette.success.main} />
        </Box>
      </Box>

      <DialogTitle style={{ textAlign: 'center' }}>Great — Messaging is now active</DialogTitle>

      <DialogContent>
        <DialogContentText style={{ textAlign: 'center' }}>
          You'll be charged £199 + VAT a month going forward. Get started with your chats now.
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button fullWidth color="primary" variant="contained" onClick={onClose}>
          Get started
        </Button>
      </DialogActions>
    </Dialog>
  );
};
